import axios from 'axios';
import type {
  ConflictCheckRecordDetail,
  ConflictCheckRecordFilter,
  ConflictCheckRecordPage,
} from '../models/conflictTypes';

const BASE = '/ConflictCheck';

/** Saving runs the scan again server-side, so it needs the scan's own allowance. */
const SAVE_TIMEOUT_MS = 45000;

const READ_TIMEOUT_MS = 15000;

export default {
  async save(
    query: string,
    includeTimeEntries: boolean,
    notes: string,
  ): Promise<ConflictCheckRecordDetail> {
    const { data } = await axios.post<ConflictCheckRecordDetail>(
      BASE,
      { query, entries: includeTimeEntries, notes: notes || null },
      { timeout: SAVE_TIMEOUT_MS },
    );
    return data;
  },

  async list(
    filter: ConflictCheckRecordFilter,
  ): Promise<ConflictCheckRecordPage> {
    const { data } = await axios.get<ConflictCheckRecordPage>(BASE, {
      params: {
        from: filter.from ?? undefined,
        to: filter.to ?? undefined,
        page: filter.page,
        pageSize: filter.pageSize,
      },
      timeout: READ_TIMEOUT_MS,
    });
    return data;
  },

  async get(id: string): Promise<ConflictCheckRecordDetail> {
    const { data } = await axios.get<ConflictCheckRecordDetail>(
      `${BASE}/${encodeURIComponent(id)}`,
      { timeout: READ_TIMEOUT_MS },
    );
    return data;
  },

  /** Only notes are accepted; the server refuses a body carrying anything else. */
  async updateNotes(
    id: string,
    notes: string,
  ): Promise<ConflictCheckRecordDetail> {
    const { data } = await axios.put<ConflictCheckRecordDetail>(
      `${BASE}/${encodeURIComponent(id)}`,
      { notes: notes || null },
      { timeout: READ_TIMEOUT_MS },
    );
    return data;
  },
};
